import { TFunction } from "i18next";
import { APP_NAME } from "../../utls/constants";

const useHomePageInfos = (t: TFunction) => {
    const pageTitle = `${t("main-page-title")} | ${APP_NAME}`;
    const pageDescription = t("main-page-description");

    document.title = pageTitle;
    
    let metaDescription = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDescription) {
        metaDescription = document.createElement("meta");
        metaDescription.name = "description";
        document.head.appendChild(metaDescription);
    }
    metaDescription.content = pageDescription;

    let linkCanonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!linkCanonical) {
        linkCanonical = document.createElement("link");
        linkCanonical.rel = "canonical";
        document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = 'https://www.twizz.app';

    let metaRobots = document.querySelector('meta[name="robots"]') as HTMLMetaElement;
    if (!metaRobots) {
        metaRobots = document.createElement("meta");
        metaRobots.name = "robots";
        document.head.appendChild(metaRobots);
    }
    metaRobots.content = "index, follow";

    let scriptJsonLd = document.querySelector('script[type="application/ld+json"]') as HTMLScriptElement;
    if (!scriptJsonLd) {
        scriptJsonLd = document.createElement("script");
        scriptJsonLd.type = "application/ld+json";
        document.head.appendChild(scriptJsonLd);
    }
    scriptJsonLd.textContent = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": APP_NAME,
        "url": "https://www.twizz.app",
        "description": pageDescription
    });

    const metaOgTags = [
        { property: "og:title", content: pageTitle },
        { property: "og:description", content: pageDescription },
        { property: "og:url", content: "https://www.twizz.app" },
        { property: "og:type", content: "website" },
    ];

    metaOgTags.forEach(tag => {
        let metaTag = document.querySelector(`meta[property="${tag.property}"]`) as HTMLMetaElement;
        if (!metaTag) {
            metaTag = document.createElement("meta");
            metaTag.setAttribute("property", tag.property);
            document.head.appendChild(metaTag);
        }
        metaTag.content = tag.content;
    });

    return () => {
        document.title = APP_NAME;
        metaDescription.content = t("app_description", { appName: APP_NAME });
        linkCanonical.remove();
        scriptJsonLd.remove();
        metaRobots.content = "";
    };
};

export default useHomePageInfos;